<template>
  <div class="p-0 md:p-2 flex flex-col items-center justify-center">
    <div class="container max-w-screen-lg mx-auto">
      <div>

        <div class="bg-white rounded shadow-lg p-4 px-4 mb-2">
          <div class="grid gap-4 gap-y-2 text-sm grid-cols-1 lg:grid-cols-3">

            <div class="text-left block">
              <p class="mb-2 font-medium text-lg text-gray-800">
                {{ descriptionTitle }}
              </p>
              <p class="text-gray-500">
                Campos com <span class="text-red-500">*</span> são obrigatórios
              </p>
            </div>

            <div id="form-fields" class="lg:col-span-2 pb-3">
              <div class="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-5">

                <!-- registro -->
                <div class="md:col-span-3">
                  <label class="text-left flex pl-1 text-xs text-[#2b3038]">
                    Tipo do afastamento <a class="text-red-600 ml-1">*</a>
                  </label>
                  <div
                    class="h-10 flex rounded items-center mt-1.5 w-full"
                  >
                  <SimpleSelect
                    class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
                    :data="pontoType"
                    :initialValue="store.type"
                    @selected-data="(val) => (store.type = val?.name)"
                  />
                  </div>

                  <span
                    name="type"
                    class="text-red-600 text-sm mt-1"
                  />
                </div>

                <!-- colaborador -->
                <div class="md:col-span-2" v-if="registerToCollab">
                  <label class="text-left flex pl-1 text-xs text-[#2b3038]">
                    Funcionário <a class="text-red-600 ml-1">*</a>
                  </label>
                  <div
                    class="h-10 flex rounded items-center mt-1.5 w-full"
                  >
                  <SimpleSelect
                    :key="store?.collabs"
                    class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
                    :data="store?.collabs"
                    :initialValue="store?.user"
                    @selected-data="(val) => {
                      store.user = val?.name
                      store.user_id = val?.value
                    }"
                  />
                  </div>

                  <span
                    name="type"
                    class="text-red-600 text-sm mt-1"
                  />
                </div>

                <!-- hospital -->
                <div class="md:col-span-2">
                  <BaseInput
                    type="text"
                    name="store.hospital"
                    v-model="store.hospital"
                    :info="'Hospital / Médico'"
                    label="Hospital / Médico"
                    :required-field="false"
                    :activeDefault="false"
                  >
                    <template #append>
                      <CleanInputButton
                        @click="store.hospital = undefined"
                      />
                    </template>
                  </BaseInput>
                </div>

                <!-- ida -->
                <div class="md:col-span-2">
                  <BaseInput
                    type="date"
                    name="store.realizado_em"
                    v-model="store.realizado_em"
                    label="Inicio do afastamento"
                    :info="'Inicio do afastamento'"
                    :required-field="false"
                    :activeDefault="true"
                  >
                    <template #append>
                      <CleanInputButton
                        @click="store.realizado_em = null"
                      />
                    </template>
                  </BaseInput>

                  <span name="store.realizado_em" class="text-red-600 text-sm" />
                </div>

                <!-- retorno -->
                <div class="md:col-span-2">
                  <BaseInput
                    type="date"
                    name="store.expired_at"
                    v-model="store.expired_at"
                    label="Data de retorno"
                    :info="'Data de retorno'"
                    :required-field="false"
                    :activeDefault="true"
                  >
                    <template #append>
                      <CleanInputButton
                        @click="store = null"
                      />
                    </template>
                  </BaseInput>
                </div>

                <!-- dias -->
                <div class="md:col-span-1 text-gray-400">
                  <BaseInput
                    type="text"
                    name="form.description"
                    :info="'Dias'"
                    label="Dias"
                    :required-field="false"
                    :activeDefault="true"
                    :disabled="true"
                    :center="true"
                    v-model="daysDifference"
                  >
                  </BaseInput>
                </div>

                <!-- obs -->
                <div class="md:col-span-5">
                  <BaseInput
                    type="text"
                    name="name"
                    v-model="store.obs"
                    :info="'Observação'"
                    label="Observação"
                    :required-field="false"
                    :activeDefault="false"
                  >
                    <template #append>
                      <CleanInputButton
                        @click="store.obs = undefined"
                      />
                    </template>
                  </BaseInput>
                </div>

                <!-- fluxo do documento -->
                <div class="flex justify-center">
                  <img
                    v-if="selectedFileUrl"
                    :src="selectedFileUrl"
                    alt="EPI"
                    class="mt-2 rounded-md w-60 max-h-60 block md:hidden"
                  />
                </div>

                <div class="md:col-span-5 mt-2 flex h-10">
                  <label
                    class="cursor-pointer bg-gray-100 hover:bg-gray-300 transition-all min-w-[8rem] h-10 rounded-l-md rounded-r-none"
                  >
                    <!-- <i class="fa-solid fa-helmet-safety"></i> -->

                    <div class="flex mt-auto mb-auto h-full">
                      <div class="w-full mt-auto mb-auto flex justify-center">
                        <component 
                          :is="selectedFileName ? PhCloudArrowUp : PhFileArrowUp"
                          class="w-5 h-5 mr-1 text-gray-500" 
                          :class="[
                            selectedFileName ? 'text-green-500' : ''
                          ]"
                        />
    
                        Documento
                      </div>
                    </div>
                    <input
                      type="file"
                      class="hidden"
                      @change="handleFileChange"
                    />
                  </label>
                  <input
                    type="text"
                    style="padding-left: 10px !important"
                    class="border rounded w-full h-10 rounded-r-md rounded-l-none"
                    :value="selectedFileName"
                  />
                </div>

              </div>
            </div>

          </div>
        </div>

        <div class="p-2 mt-1 mb-1" />

        <div>
          <slot />
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import CleanInputButton from '../components/CleanInputButton.vue'
import SimpleSelect from '@/components/Select/SimpleSelect.vue'
import BaseInput from '@/components/Inputs/BaseInput.vue'
import { PhCloudArrowUp, PhFileArrowUp } from '@phosphor-icons/vue'
import { showToast as toast } from '@/helpers/UseToasts'
import { pontoType } from '../lookups/form'
import { dataAfastamento } from '../store'
import { storeApp } from '@/store'
import moment from 'moment'
import { ref } from 'vue'

export default {
  name: 'FormVue',
  components: {
    CleanInputButton,
    BaseInput,
    PhCloudArrowUp,
    SimpleSelect,
  },
  props: {
    descriptionTitle: String
  },
  data () {
    const store = dataAfastamento.state
    const fileUrl = process.env.VUE_APP_IMAGE_SERVE + 'storage/'

    let permissions = localStorage.getItem('__permissions')
    let permissionArray = permissions?.split(',');
    const registerToCollab = ref(
      permissionArray.includes('afas_fun')
    )

    return {
      PhCloudArrowUp, 
      PhFileArrowUp,
      store,
      fileUrl,
      toast,
      selectedFileName: undefined,
      selectedFileUrl: undefined,
      pontoType,
      moment,
      currentTime: new Date().toLocaleTimeString(),
      interval: null,
      storeApp,
      registerToCollab
    }
  },
  computed: {
    daysDifference() {
      const { realizado_em, expired_at } = this.store;
      
      if (realizado_em && expired_at) {
        const startDate = moment(realizado_em);
        const endDate = moment(expired_at);

        const diff = endDate.diff(startDate, "days");

        this.store.dias = diff

        return diff >= 0 ? diff : 0;
      }

      return '';
    },
  },
  methods: {
    handleFileChange (event) {
      const file = event.target.files[0]
      if (file) {
        this.selectedFileName = file.name
        this.selectedFileUrl = URL.createObjectURL(file)
        
        this.store.docName = this.selectedFileName
        this.store.doc = file
      }
    },
    updateClock() {
      this.currentTime = new Date().toLocaleTimeString();
    },
  },
  mounted() {
    this.interval = setInterval(this.updateClock, 1000);
    this.store.registeredTime = this.currentTime
  },
  beforeUnmount() {
    clearInterval(this.interval);
  },
}
</script>
